import languages from "../../languages"

/**
 * A temporary workaround that lets us access our translation strings from within the Gatsby Head export.
 * In the future the hope is that we can replace this like-for-like with the useTranslation() hook from 'gatsby-plugin-react-i18next'.
 *
 * @param {import("gatsby-plugin-react-i18next/dist/types").PageContext} pageContext
 * @param {{locales: {edges: {node: {language: string; ns: string; data: string}}[]}}} data
 * @returns {{t: (key: string) => string}}
 */
const useHeadTranslation = ({ pageContext, data }) => {
  const defaultLanguage = languages.find(lang => lang.default).key

  const currentLanguageEdges = data.locales.edges.filter(
    edge => edge.node.language === pageContext.language,
  )

  const defaultLanguageEdges = data.locales.edges.filter(
    edge => edge.node.language === defaultLanguage,
  )

  return {
    t: key => {
      const path = key.split(".")

      const namespace = path[0]

      // Account for no json file existing for target locale
      const currentLanguageEdge =
        currentLanguageEdges.find(edge => edge.node.ns === namespace) ??
        defaultLanguageEdges.find(edge => edge.node.ns === namespace)

      const translationsForCurrentLanguage = JSON.parse(
        currentLanguageEdge.node.data,
      )

      // I don't like that this is really hard to understand. It's essentially letting us do `translations['about.title']` where "about.title" is dynamic. 🤔
      const translationString = path.reduce(
        (arr, pathSegment) => arr[pathSegment],
        translationsForCurrentLanguage,
      )

      // If the key doesn't exist in target language, use default language or fallback to displaying the key if it doesn't exist in the default language either.
      if (!translationString) {
        const translationsForDefaultLanguage = JSON.parse(
          defaultLanguageEdges.find(edge => edge.node.ns === namespace).node
            .data,
        )

        return (
          path.reduce(
            (arr, pathSegment) => arr[pathSegment],
            translationsForDefaultLanguage,
          ) ?? key
        )
      }

      return translationString
    },
  }
}

export default useHeadTranslation
